// extracted by mini-css-extract-plugin
module.exports = {"vat":"Price-module__vat___3C10-"};